export default __webpack_public_path__ + "static/media/Gloves of the Bloodhunter (nm).3252ff77.jpg";